import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'src/app/services/message.service';
import { EditbaseComponent } from '../../editbase.component';
import { SubmenuService } from '../../submenu/submenu.service';
import { FormactionService } from 'src/app/services/formaction/formaction.service';

@Component({
  selector: 'app-formaction-form',
  templateUrl: './formaction-form.component.html',
  styleUrls: ['./formaction-form.component.less']
})
export class FormactionFormComponent extends EditbaseComponent implements OnInit {


  model:any = {
    Name:"",
  };
  activetab :string = "basic-info";

  constructor(private activatedRoute: ActivatedRoute, public formActionServide: FormactionService, public messageService:MessageService, 
    public submenuService:SubmenuService, public translate: TranslateService, private router:Router) { 

      super();
    }

  ngOnInit(): void {
    let id = this.activatedRoute.snapshot.params.id;

    if(id>0)
    {
      this.messageService.showLoading();
      this.formActionServide.loadById(id).subscribe((data:any) => {
        this.model = data;
        this.messageService.hideLoading();
      });
    }
  }

  setActiveTab(tabName:string){
    this.activetab  = tabName;
  }

  ngAfterViewChecked(){
    this.submenuService.showRecordDetails("/formaction", this);  
  }

  save() {
    this.messageService.showLoading();
   this.formActionServide.save(this.model).subscribe((data:any) => {

      this.model = data;
      this.messageService.hideLoading();
      this.messageService.showMessage("Data saved successfuly.", "success");

    });
  }

  delete() {
    this.messageService.showLoading();
    this.formActionServide.delete(this.model).subscribe((data:any) => {
      this.messageService.hideLoading();
      this.messageService.showMessage("Data saved successfuly.", "success");
      this.router.navigate(['formaction']);
    },
  err=>{
    this.messageService.hideLoading();
    this.messageService.showMessage("Error deleting.", "error");
  });
  }
}
